import React from "react";
import { link, clientName } from "../../constants";

const Footer = () => {
  return (
    <footer className="page-footer font-small blue pt-4">
      <div className="footer-copyright text-center py-3">
        © {new Date().getFullYear()} Copyright:
        <a className="link-primary p-2" target="_blank" href={link}>
          {clientName}
        </a>
      </div>
    </footer>
  );
};

export default Footer;
